import { GroupResource, GroupViewModel } from '../../models'

export default function transformGroupResource(group: GroupResource): GroupViewModel {
    return {
        id: group.id,
        name: group.name,
    }
}
